import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { MdTextContent } from '../MdTextComponent/MdTextContent'
import { useGetMdText } from '../MdTextComponent/useGetMdText'
import { DataTableV2DataRow } from '../DataTableV2/types'
import { transformTitleValueObjectsToValues } from '../DataTableV2/utils'

type SheetMdTextData = Record<string, unknown> & {
  id?: string | number
}

export function SheetMdTextComponent({
  contentId,
  formData,
}: {
  contentId: string
  formData?: SheetMdTextData
}) {
  const { tileFilterSelections } = useTileFilters()
  const hasRowId = typeof formData?.id === 'string' || typeof formData?.id === 'number'
  const payload = formData
    ? {
        formData: hasRowId
          ? transformTitleValueObjectsToValues(formData as DataTableV2DataRow)
          : (formData as Record<string, unknown>),
      }
    : undefined
  const { data, refetch } = useGetMdText(contentId, tileFilterSelections, payload)

  return (
    <div className="flex h-full min-h-0 flex-col">
      <MdTextContent
        contentId={contentId}
        cachedResponse={data}
        sheetPayload={payload}
        uiSchema={data.uiSchema}
        dataSchema={data.dataSchema}
        reloadHandler={refetch}
      />
    </div>
  )
}
